import moment from 'moment-timezone';
import { connect, useDispatch } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import DialerPad from "../../../assets/static/images/dialpad.svg";
import { callPopUpEdit, voipEdit } from '../../../redux/actions/addOns/voip/voipActions';
import { procedurePricingsLoad } from '../../../redux/actions/storeSettings/ProcedurePricingActions';
import { currentStoreLoad, storeStaffsLoad, currentStoreAll } from '../../../redux/actions/currentStoreActions';
import Alert from '../../../itrust_common/components/Alert';
import { useEffect } from 'react';
import { storeSettingLoad } from '../../../redux/actions/storeSettings/storeSettingActions';
import { useParams } from 'react-router-dom';
import { staffStoresLoad } from '../../../redux/actions/staffStoreActions';
import TooltipComponent from '../../../itrust_common/components/others/TooltipComponent';


function StoreSelection(props) {
  const { storeId, staffStores, storeTimezone, user, add_ons_config, staffsId, currentStore } = props
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  let localStorageStoreId = localStorage.getItem('StoreID')
  let localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone


  useEffect(() => {
    localStorage.setItem('User-email', user.email)
    localStorage.setItem('User-firstname', user.first_name)
    localStorage.setItem('User-lastname', user.last_name)
    if (localStorageStoreId)
      handleStoreSelection(localStorageStoreId)
    else if (user.role == 'non_admin' || staffStores.length == 1) {
      if (staffStores[0]) {
        localStorage.setItem('StoreID', staffStores[0].store_id)
        handleStoreSelection(staffStores[0].store_id)
      }
    }
    dispatch(storeSettingLoad({ filter: { store_id: localStorageStoreId || 'default_status' }, page: 1, rpp: 999999999, sort: 'position', direction: 'asc' }))
  }, [])

  const handleStoreSelection = (id) => {
    if (id === "") {
      localStorage.removeItem('StoreID');
      dispatch(currentStoreAll())
    }
    else {
      localStorage.setItem('StoreID', id);
      // const { location, history, storeId } = props
      dispatch(currentStoreLoad())
      dispatch(storeStaffsLoad(id, { rpp: 1000, filter: { doctor: id } }))
      dispatch(procedurePricingsLoad({ rpp: 99999, filter: { for_store: id }, include: ['procedures'] }))
      if (location.pathname.includes('/organisation/stores/') && storeId && storeId != id) {
        var route = location.pathname.split('/')
        history.push(`/organisation/stores/${id}/settings/store/store-setting`)
      }
    }
    dispatch(storeSettingLoad({ filter: { store_id: id || 'default_status' }, page: 1, rpp: 999999999, sort: 'position', direction: 'asc' }))
  }

  const timezoneDiff = (storeTimezone, localTimezone) => {
    let storeTimezoneOffest = moment.tz(storeTimezone)._offset;
    let localTimezoneOffest = moment.tz(localTimezone)._offset;

    if (storeTimezoneOffest > localTimezoneOffest) {
      return (<span className="badge bg-danger-light p-3">
        <i className="la la-sm la-clock-o" />
        Time Zone: {(Math.abs(storeTimezoneOffest - localTimezoneOffest)) / 60} hrs behind
      </span>)
    } else {
      return (<span className="badge bg-danger-light p-3">
        <i className="la la-sm la-clock-o" />
        Time Zone: {(Math.abs(storeTimezoneOffest - localTimezoneOffest)) / 60} hrs ahead
      </span>)
    }
  }
  const handleOpenDialer = (id) => {
    if (storeId) {
      dispatch(callPopUpEdit(id))
      dispatch(voipEdit({ activePopupTab: 'dialer' }))
    }
    else {
      Alert.warning('Please select store from top dropdown.')
    }
  }

  return (
    <div className="d-flex justify-content-end align-items-center mx-3 mx-md-4 mx-lg-5">
      {user.type !== 'Patient' &&
        <>
          {add_ons_config?.type?.voip?.visible &&
            <button className='btn bg-light-1 py-4 px-4 mr-4' onClick={() => handleOpenDialer('store_calling')}>
              <TooltipComponent title="Dial Pad"><img src={DialerPad} alt='voip-call' /></TooltipComponent>
            </button>
          }
          {storeId && storeTimezone !== localTimezone && timezoneDiff(storeTimezone, localTimezone)}
          <label className="text-muted px-5">Accessing</label>
          <select className="custom-select store-select" onChange={(e) => handleStoreSelection(e.target.value)} value={storeId} style={{minWidth: 'fit-content'}}>
            {staffStores.length !== 1 && user.role !== 'non_admin' &&
              <option value="" selected>All</option>
            }
            {staffStores.map(store =>
              <option key={store.store_id} value={store.store_id}>{store.store_name}</option>
            )}
          </select>
        </>
      }
      {
        user.type !== "Patient" && user.role !== 'non_admin' && storeId ? (
          <Link to={`/organisation/stores/${storeId}/settings/store`}>
            <TooltipComponent title="Store Setting"><i className="la la-cog pt-3 text-muted px-5" /></TooltipComponent>
          </Link>
        ) : (
          user.role === 'non_admin' &&
          staffsId &&
          currentStore?.store?.permissions?.find(
            (item) => item.app_module_name === "settings"
          )?.permissions?.can_view && (
            <Link to={`/organisation/staffs/${staffsId}/staff-detail`}>
              <i className="la la-cog pt-3 text-muted px-5" title="Store Settings" />
            </Link>
          )
        )
      }

    </div >
  )
}

const mapStateToProps = state => {
  const { currentStore, auth, organisation: { organisation } } = state
  return {
    storeTimezone: currentStore.store.timezone,
    storeId: currentStore.store.id,
    user: auth.user,
    staffStores: auth.user.accessible_stores,
    staffsId: auth.user.id,
    // staffStores: staff_stores.filter((staffStore) => staffStore.designation === 'doctor' || staffStore.designation === 'doctor_superadmin' || staffStore.designation === 'doctor_admin'),
    add_ons_config: organisation.add_ons_config,
    currentStore
  }
}

export default connect(mapStateToProps)(StoreSelection);